import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../../mock/system/auth.service';

@Injectable()
export class PageGuard {


    constructor(
        private router: Router,
        private cookie: CookieService
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        const wmt_id = Number(this.cookie.get('wmt_id'));

        const token = this.cookie.get('AuthToken');

        if (!token) {
            this.router.navigate(['/public']);
            return false;
        }

        const data = Array.isArray(next.data) ? next.data : Object.values(next.data);

        console.log(`data page-guard ${wmt_id}`, data);

        if (wmt_id) {
            console.log('wmt_id', wmt_id);
            if (!data.includes(wmt_id)) {
                if (wmt_id == 12) {
                    this.router.navigate(['/pages/budget']);
                } else {
                    this.router.navigate(['/pages/dashboard']);
                }
                return false;
            }
        }

        return true;

    }

}
